import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const ProjectModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            opacity="0.9"
            x="8"
            y="9.5"
            width="8"
            height="0.75"
            rx="0.375"
            fill="#E8E8E8"
          />
          <rect
            opacity="0.9"
            x="8"
            y="11.5"
            width="8"
            height="0.75"
            rx="0.375"
            fill="#E8E8E8"
          />
          <rect
            opacity="0.9"
            x="8"
            y="13.5"
            width="6"
            height="0.75"
            rx="0.375"
            fill="#E8E8E8"
          />
          <rect
            x="7"
            y="5"
            width="10"
            height="4"
            rx="2"
            stroke="url(#paint0_linear_123_14417)"
            stroke-width="2"
          />
          <path
            d="M4 11C4 9.34315 5.34315 8 7 8H17C18.6569 8 20 9.34315 20 11V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V11Z"
            fill="url(#paint1_linear_123_14417)"
          />
          <path
            d="M4 10C4 8.34315 5.34315 7 7 7H17C18.6569 7 20 8.34315 20 10V11C20 12.6569 18.6569 14 17 14H7C5.34315 14 4 12.6569 4 11V10Z"
            fill="url(#paint2_linear_123_14417)"
          />
          <rect x="10" y="13" width="4" height="2" rx="1" fill="#00157B" />
          <defs>
            <linearGradient
              id="paint0_linear_123_14417"
              x1="12"
              y1="3"
              x2="12"
              y2="7"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#564DB8" />
              <stop offset="1" stop-color="#FB72F9" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_14417"
              x1="10"
              y1="11"
              x2="10"
              y2="20"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FB45E8" />
              <stop offset="1" stop-color="#FFD2D7" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_123_14417"
              x1="13.5"
              y1="7"
              x2="13.5"
              y2="14"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#DE25CB" />
              <stop offset="1" stop-color="#FFD6D6" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default ProjectModule;
